import React from "react";
import { useAuth } from "../../../hooks/auth";
import {
  Box,
  Typography,
  Stack,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  AccountCircle,
  ReceiptLong,
  SupportAgent,
  Settings,
  Reviews,
  Logout,
  VerifiedUser,
  Dashboard,
  GppMaybe,
} from "@mui/icons-material";
import { Bottombar } from "../../../components/Bottombar";
import "./style.css";
import { useNavigate } from "react-router-dom";

export const More = () => {
  const { logout, cookies } = useAuth();
  const navigate = useNavigate();
  const moreList = [
    {
      text: "Profile Info",
      icon: <AccountCircle />,
      rel_url: "/profile",
    },
    {
      text: "Dashboard Summary",
      icon: <Dashboard />,
      rel_url: "/dashboard",
    },
    {
      text: "Transaction History",
      icon: <ReceiptLong />,
      rel_url: "/transactions",
    },
    {
      text: "Help & Support",
      icon: <SupportAgent />,
      rel_url: "/help",
    },
    {
      text: "Settings",
      icon: <Settings />,
      rel_url: "/settings",
    },
    {
      text: "Rate Us",
      icon: <Reviews />,
      rel_url: "/rating",
    },
    {
      text: "Logout",
      icon: <Logout />,
      rel_url: "/login",
    },
  ];

  const handleClick = (obj) => {
    if (obj.text === "Logout") {
      logout();
      navigate(`${obj.rel_url}`);
    } else {
      navigate(`${obj.rel_url}`);
    }
  };

  return (
    <Box>
      <Box
        sx={{
          backgroundColor: "primary.main",
          height: "210px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Stack spacing={2}>
          <img
            src="FORTUNE_PRECIOUS.jpg"
            alt="fortune precious pic"
            class="profile_pic"
          />
          <Stack direction="row" spacing={1} color="mywhite.main">
            <Typography variant="body1" display="inline-block">
              {`${cookies.data.first_name} ${cookies.data.last_name}`}
            </Typography>
            {cookies.data.is_verified ? <VerifiedUser /> : <GppMaybe sx={{color:"orange"}} />}
          </Stack>
        </Stack>
      </Box>
      <List>
        {moreList.map((value, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton
              onClick={() => {
                handleClick(value);
              }}
            >
              <ListItemIcon>{value.icon}</ListItemIcon>
              <ListItemText primary={value.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Bottombar value={2} />
    </Box>
  );
};
